import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';

export function useModels() {
  return useQuery({
    queryKey: ['models'],
    queryFn: api.listModels,
    staleTime: 120_000, // models don't change often
  });
}

export function useTools() {
  return useQuery({
    queryKey: ['tools'],
    queryFn: api.listTools,
    staleTime: 120_000,
  });
}
